class Accordion {

    constructor($accordion) {
        if (!$accordion) {
            return;
        }
        this.$accordion = $accordion;
        this.$groups = this.$accordion.querySelectorAll('[data-accordion-group]');
        if (this.$groups.length) {
            this.setup();
        }
    }

    setup(){
       this.$groups.forEach(($group) => {
           this.setupGroup($group);
       });
    }

    setupGroup($group) {
        const yOffset = -100;
        const $toggle = $group.querySelector('[data-accordion-group-toggle-button]');
        const $list = $group.querySelector('[data-list-transition]');
        if (!$list) {
            console.warn('no lists found, within accordion')
            return;
        }

        // Add an event listener that will trigger the list transition,
        // and close all other lists within the accordion.
        $toggle.addEventListener('click', () => {
            const listState = $list.triggerTransition();

            // If the listState is open, then add the c-button--active class to the current toggle, and remove it from
            // all the other toggles.
            // If the listState is closed, remove the c-button--active class from the current toggle.
            if (listState === 'open') {
                $toggle.classList.add('c-button--active');
                const $otherToggles = this.$accordion.querySelectorAll('[data-accordion-group-toggle-button]');
                $otherToggles.forEach(($ot) => {
                    if ($ot !== $toggle) {
                        $ot.classList.remove('c-button--active');
                    }
                });
            } else {
                $toggle.classList.remove('c-button--active');
            }

            // If the list state is open after the triggerTransition call,
            // then close all other lists within the accordion.
            if (listState === 'open') {
                const $allListTransitions = this.$accordion.querySelectorAll('[data-list-transition]');
                $allListTransitions.forEach(($listTransition) => {
                    if ($listTransition !== $list) {
                        $listTransition.setTransitionOut();
                    }
                });

                setTimeout(() => {
                    const y = $toggle.getBoundingClientRect().top + window.scrollY + yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                }, 700);

            }
        });
    }

    static setupAllAccordions() {
        const $accordions = document.querySelectorAll('[data-accordion]');
        $accordions.forEach(($accordion) => {
            new Accordion($accordion);
        });
    }
}

Accordion.setupAllAccordions();
